/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import { useTranslation } from 'react-i18next';
import useSubmissionStatusChangeDialog from './useSubmissionStatusChangeDialog';

export default function SubmissionStatusChangeDialog(props) {
  const { open, handleCancel, handleConfirm, submission, revertStatusAction } = props;
  const { t } = useTranslation();

  const {
    handleChange,
    storeSubmissionStatusChange,
    cancelDialog,
    comments,
    messages,
    loading,
  } = useSubmissionStatusChangeDialog(submission, handleConfirm, handleCancel, revertStatusAction);

  return (
    <div>
      <Dialog open={open} fullWidth maxWidth="lg">
        <DialogTitle>
          <Typography component="h2" variant="h2">
            {messages.sendBackTo}
          </Typography>
        </DialogTitle>
        <DialogContent>
          {messages.warning}
          <Typography variant="body1" component="p" gutterBottom style={{ paddingTop: '2rem' }}>
            {messages.comment}
          </Typography>
          <TextField
            autoFocus
            id="changeStatusComment"
            fullWidth
            multiline
            rows={4}
            value={comments}
            onChange={handleChange}
          />
        </DialogContent>
        <DialogActions>
          <Button id="cancelStatus" color="default" variant="contained" onClick={cancelDialog}>
            {t('actions.cancel')}
          </Button>
          <Button
            id="confirmStatus"
            color="primary"
            variant="contained"
            onClick={storeSubmissionStatusChange}
            disabled={loading}
          >
            {loading ? t('change.to.ready.to.sign.status.processing', 'Loading...') : t('actions.confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
